import React from 'react';

export const Select = ({ label, value, onChange, options }) => (
  <div>
    <label className="text-xs text-[var(--isp-body)]">{label}</label>
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="mt-1 w-full rounded-xl bg-slate-950/40 border border-[var(--isp-glass-border)] px-3 py-2 text-sm text-[var(--isp-body)] outline-none"
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  </div>
);

export const Th = ({ children }) => (
  <th className="text-left font-semibold px-4 py-3 whitespace-nowrap">{children}</th>
);

export const Td = ({ children, className = '' }) => (
  <td className={`px-4 py-3 text-[var(--isp-body)] whitespace-nowrap ${className}`}>{children}</td>
);

export const parseDate = (s) => {
  if (!s) return null;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return null;
  return d;
};

export const daysUntil = (s) => {
  const d = parseDate(s);
  if (!d) return null;
  const diffMs = d.getTime() - Date.now();
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
};
